import { MEAL_PLAN_30_PROMO_CODES, REGION_ID_TO_REGION_PROMO_CODE } from 'common/Constants';
import { PromoCodeType, useGetNewUserPromoCodeQuery } from 'src/gqlReactTypings.generated.d';
import { usePromotionalsHook } from 'src/promotionals/usePromotionalsHook';
import { useUserPreferences } from 'src/user-preferences/useUserPreferences';
import { match } from 'ts-pattern';
import { useZipCode } from './useZipCode';

export const useGetSignupPromo = () => {
  const { data, loading } = useGetNewUserPromoCodeQuery();
  const { code: currentPromoCode } = usePromotionalsHook();

  const [{ zipcode }] = useUserPreferences();
  const { data: zipCodeData } = useZipCode(zipcode ?? '');
  const region = zipCodeData?.zipCode?.region?.id;

  const isInMealPlanRegion = region && REGION_ID_TO_REGION_PROMO_CODE[region];

  return match(currentPromoCode)
    .with({ promoCodeType: PromoCodeType.Referral }, { isShefToConsumerPromo: true }, () => ({
      signupPromo: currentPromoCode,
      loading: false,
    }))
    .when(
      (promo) => promo?.code && MEAL_PLAN_30_PROMO_CODES.includes(promo.code) && isInMealPlanRegion,
      () => ({
        signupPromo: currentPromoCode,
        loading: false,
      })
    )
    .otherwise(() => ({ signupPromo: data?.newUserPromoCode, loading }));
};
